import { trackPageView, trackSwitchMainTab } from '@/services/tracking'
import Vue from 'vue'
import VueRouter from 'vue-router'
import privateRoutes from './privateRoutes'
import publicRoutes from './publicRoutes'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '*',
  //   component: () => import('@/views/Maintenance.vue'),
  //   meta: {
  //     layout: 'Default',
  //   },
  // },

  ...publicRoutes,
  ...privateRoutes,

  {
    path: '*',
    component: () => import('@/views/PageNotFound.vue'),
    meta: {
      layout: 'Default',
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

router.beforeEach((to, from, next) => {
  trackPageView(to.fullPath)
  if (to.meta?.mainTab) {
    trackSwitchMainTab(to.name || '')
  }
  next()
})

export default router
